import { render, staticRenderFns } from "./BestBusinessInTownCard.vue?vue&type=template&id=b5de8cea&scoped=true&"
import script from "./BestBusinessInTownCard.vue?vue&type=script&lang=js&"
export * from "./BestBusinessInTownCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5de8cea",
  null
  
)

export default component.exports